import getComponentRootDom from "@/utils/getComponentRootDom";
import Icon from '@/components/Icon'
import styles from './message.module.less'

export default function (options){
    const content = options.content || ''
    const type = options.type || 'info'
    const duration = options.duration || 2000
    const container = options.container || document.body
    const onClose = options.onClose || function(){}

    const iconDom = getComponentRootDom(Icon, {
        type
    })
    const div = document.createElement('div')
    div.className = `${styles.message} ${styles[`message-${type}`]}`
    div.innerHTML = `<span class="${styles.icon}">${iconDom.outerHTML}</span><div>${content}</div>`
    if(options.container) {
        if(getComputedStyle(container).position === 'static'){
            container.style.position = 'relative'
        }
    }
    
    container.appendChild(div)
    // 浏览器强行渲染
    div.clientHeight
    // 回归到正常位置
    div.style.opacity = 1
    div.style.transform = 'translate(-50%, -50%)'
    setTimeout(() => {
        div.style.opacity = 0
        div.style.transform = 'translate(-50%, -50%) translateY(-25px)'
        div.addEventListener('transitionend', () => {
            div.remove()
            onClose()
        }, {
            once: true
        })
    }, duration)
}